import * as types from '../actions/header/types';

const INITIAL_STATE = {
  backButton: false,
  title: '',
};

export default function headerReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.HEADER_TITLE:
      return {
        ...state,
        title: action.payload
      };

    case types.HEADER_BACK_BUTTON:
      return {
        ...state,
        backButton: action.payload
      };

      default: return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/headerReducer.js